import Base from './base';
import {
  PODCAST_SUBSCRIPTION_TAG_NAME,
  PODCAST_SUBSCRIPTION_SAMPLE_CLASS
} from '../../classnames/blog';
import { HIDDEN } from '../../classnames/design-system';

export default class PodcastSubscription extends Base {
  tagName = PODCAST_SUBSCRIPTION_TAG_NAME;
  sample = document.querySelector(`.${PODCAST_SUBSCRIPTION_SAMPLE_CLASS}`);

  buildNode = (_placeholder) => {
    const newNode = this.sample.cloneNode(true);

    newNode.classList.remove(PODCAST_SUBSCRIPTION_SAMPLE_CLASS, HIDDEN);

    return newNode;
  };
}
